import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Button, Modal, Header, Icon, Message } from 'semantic-ui-react'
// import _find from 'lodash/find';
import _ from 'lodash';
// import JsBarcode from 'jsbarcode';
// import { saveAs } from 'file-saver';
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'

import codBarras from '../../../functions/codbarras'

// import ImprFactEC from '../../../components/funcionales/imprfactec'
import imprFactEC from '../../../components/funcionales/imprfactec'
// import SeguroPermite from '../../../components/funcionales/seguropermite'

import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import ListaZo from '../../../components/funcionales/dirmayor/listazo';
import ListaBa from '../../../components/funcionales/dirmayor/listaba';
import selDirmayor from '../../../functions/seldirmayor';

// "use strict";

// //dropdown PROCESOS DE FACT
// const DetalleNivel1 = props => {
//   return (
//     <option dato1={props.elemento.observaciones} dato2={props.elemento.codProcFact}
//         value={props.elemento._id} style={props.styles.input}>{props.elemento.descrDpto} ={">"} {props.elemento.nombreCiudad} ={">"} {props.elemento.descrClaseServ} ={">"} RANGO: {props.elemento.factInicial} - {props.elemento.factFinal} ={">"} CICLO: {props.elemento.cicloFact}</option>
//   )
// };

// const Lista = ({styles, list, handleChange}) => {
//   const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
//   return(
//     <div>
//       <select style={styles.input} className="ui simple selection dropdown fluid" name="proceso" id="miListaP"  onChange={(ev)=>handleChange(ev)}>
//         <option style={styles.input} value="">Todos...</option>
//         {Nivel1Detalle}
//       </select>
//     </div>
//   )
// };
// //Fin dropdown PROCESOS DE FACT

//Lista de facturas
const FactCli = ({elemento}) => {
  return(
    <tr className=''>
      <td className='' style={{width: '10%'}}>{elemento.contrato}</td>
      <td className='' style={{width: '15%'}}>{elemento.nombreCliente}</td>
      <td className='' style={{width: '15%'}}>{elemento.apellidoCliente}</td>
      <td className='' style={{width: '12%'}}>{elemento.numeroDoc}</td>
      <td className='right aligned' style={{width: '10%'}}>{elemento.saldoPendiente}</td>
      <td className='' style={{width: '15%'}}>{elemento.eMail?elemento.eMail:""}</td>
      <td className='' style={{width: '12%'}}>{elemento.telefono1?elemento.telefono1:""}</td>
      <td className='' style={{width: '18%'}}>{elemento.dirmayor.ciudades.zonas.barrios.nombreBarrio}</td>
    </tr>
  )
};

const ListaFact = ({list}) => {
  const nivel1Detalle = list.map((elemento, _id) => <FactCli elemento={elemento} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

// const fechaHoy = new Date()
// let agnoHoy = fechaHoy.getFullYear()
// let mesHoy = ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1))
// let fechaHoy = new Date()
// // let fechaIni = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-01'
// fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

class FactONE2 extends React.Component {
  state={argsDocum: {contrato: "", mes: "", saldoPendiente: 0, checkSaldoPendiente: false, diasMora: 0, checkMora: false, desdeF: this.props.fechaIni,
        hastaF: ""}, totFras: 0, listFact: [],
        printFras: "uno", stImprFact: false, clientesFra: [], argsSelDpto: this.props.argsSelDpto,
        observaciones: "", factPdf_envCorr: "", permiteUpdate: true, confirmaAct: false, open: false, errors: []}
        
  //ACTUALIZAR BD
  crudBD = async (operacionCRUD, args, i)=>{
    // console.log("CRUD")
    if(args.ctrlCampo === 'CRUD'){
      // console.log(i)
      // console.log(args)
      const {data} = await operacionCRUD({
        variables: args
      });

      //Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        // console.log("MANY")
        // console.log(args)
        await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    let codigo = 0
    // console.log(argsCrud)
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    // console.log("inicio")
    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
    console.log("final")
  }

  handleChange = (ev) => {
    // console.log(ev.target.name)
    // console.log(ev.target.value)
    // console.log(ev.target.checked)
    if(ev.target.name==="imprimir"){
      if(ev.target.checked===true){
        this.setState({printFras: ev.target.value})
      }
    }else{
      if(ev.target.name==="proceso"){
        var miLista = document.getElementById("miListaP");
        this.setState({observaciones: miLista.options[miLista.selectedIndex].attributes[0].value})
      }else{
        // if(ev.target.name==="mes"){
        //   this.setState({observaciones: ""})

        //   let argsBuscarFact={}
        //   argsBuscarFact.agno = ev.target.value.substr(0, 4)
        //   argsBuscarFact.mes = ev.target.value.substr(5, 2)
        //   this.props.allFacturacion.refetch(argsBuscarFact)
        // }
        const argsDocum = this.state.argsDocum
        // if(ev.target.name === "checkSaldoPendiente"||ev.target.name === "checkDiasMoraFin"){
        if(ev.target.name === "checkSaldoPendiente"||ev.target.name === "checkMora"){
            argsDocum[ev.target.name] = ev.target.checked
        }else{
          argsDocum[ev.target.name] = ev.target.value
        }
        let listFact = []
        let totFras = 0
        this.setState({argsDocum, listFact, totFras})
      }
    }
    // console.log(this.state.argsDocum)
    this.setState({stImprFact: false})
    this.setState({confirmaAct: false})
  }

  // handleChangeCSV = async (ev) => {
  //   // console.log(ev.target.name)
  //   let errors = []
  //   if(!this.props.list||!this.props.list2||!this.props.allClientesRtes.allClientesRtes){
  //     errors.push({path: "Enviar Fact", message: "Proceso de cargue de la información, por favor espere un momento..."});
  //   }
  //   this.setState({errors})
  //   if(errors.length===0){
  //     const updState = (listFact, clientesFra, totFras, errors) => {
  //       this.setState({listFact, clientesFra, totFras, errors})
  //     };
  //     if(ev.target.name==="archcsv"||ev.target.name==="checkTieneEncab"){
  //       let checkTieneEncab = document.getElementById("checkTieneEncab").checked
  //       let fileInput = document.getElementById("archcsv")
  //       if(fileInput.files.length>0){
  //         let archcsv = ""
  //         // console.log(fileInput.files[0].name) //Nombre del archivo seleccionado
  //         let reader = new FileReader();
  //         // reader.onload = function () {
  //         reader.onload = async (ev) => {
  //           archcsv = reader.result
  //           // document.getElementById('out').innerHTML = archcsv;

  //           //asignar los datos del archivo a archivo
  //           let archivo = archcsv.toString()
  //           //guardar en array lines, cada linea del archivo
  //           let lines = archivo.split(/\n/)
  //           let numFras = 0, linea = 0, totFras = 0
  //           let listFact = [], clientesFra = []
  //           // console.log(lines.length)
  //           // lines.forEach(line => {

  //           document.body.style.cursor = 'wait'

  //           for(let iii=0; iii<lines.length-1; iii++){
  //             let line = lines[iii]
  //             if(line&&(numFras>0||(numFras===0&&!checkTieneEncab))){
  //               // console.log(iii, line)

  //               linea += 1
  //               //crear array de campos para cada linea
  //               let campos = line.split(";")

  //               if(campos.length!==12&&campos.length!==13){
  //                 errors.push({path: "Fact errada", message: "Archivo con error en la información en la línea " + linea});
  //               }else{
  //                 let argsBuscarFact = `'numeroFra': '${campos[0]}'`
  //                 argsBuscarFact = '{' + argsBuscarFact + '}'

  //                 // console.log(argsBuscarFact)
  //                 let tipoqry = `[{$match: ${argsBuscarFact}},`
  //                 argsBuscarFact = {tipoqry: `${tipoqry}
  //                   {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
  //                   {$match: {'cliente.saldoPendiente': {$gt: 0}}},
  //                   {$project: {numeroFra: 1, contrato: 1, nombreCliente: 1, apellidoCliente: 1,
  //                     nombreBarrio: 1, fechaFact: 1, codProcFact: 1,
  //                     agno: 1, mes: 1, valorAntesImptos: 1, valorFacturado: 1, valorFactura: 1,
  //                     detalleFact: 1, cliente: 1}},
  //                 ]`}
  //                 // console.log(argsBuscarFact)
  //                 let listFactTemp = []
  //                 if(argsBuscarFact){
  //                   let {data} = await this.props.allFactRtes.refetch(argsBuscarFact)
  //                   listFactTemp = await data.allFactRtes
  //                 }

  //                 for(let ii=0; ii<listFactTemp.length; ii++){
  //                   let elemento = {...listFactTemp[ii], eMail: listFactTemp[ii].cliente[0].eMail?listFactTemp[ii].cliente[0].eMail:"", telefono1: listFactTemp[ii].cliente[0].telefono1?listFactTemp[ii].cliente[0].telefono1:""}
          
  //                   let documFra = elemento
  //                   let modeloCodBarras = this.props.empresa.modeloCodBarras
  //                   let codBarrasRdo = elemento.codBarrasRdo?elemento.codBarrasRdo:this.props.codBarrasRdo
  //                   let imgSource = await codBarras(documFra, modeloCodBarras, codBarrasRdo)
  //                   listFact.push({...elemento, codBarras: imgSource})
  //                   clientesFra.push(elemento.cliente[0])

  //                   totFras += 1
  //                 }
  //               }
  //             }
  //             numFras += 1

  //             if(numFras===lines.length-1){
  //               document.body.style.cursor = 'default'
  //             }
  //           }
  //           updState(listFact, clientesFra, totFras, errors)
  //         };
  //         // start reading the file. When it is done, calls the onload event defined above.
  //         reader.readAsBinaryString(fileInput.files[0]);
  //       }else{
  //         this.setState({listFact: [], totFras: 0, errors: []})
  //       }
  //     }
  //   }
  // }

  handleSubmit = async (ev, argsDocum)=>{
    let archPdf = ev.target.name

    document.body.style.cursor = 'wait'
    let errors = []

    if(!this.props.list||!this.props.list2||!this.props.allClientesRtes.allClientesRtes){
      errors.push({path: "Enviar Fact", message: "Proceso de cargue de la información, por favor espere un momento..."});
      archPdf = "nohaydatos"
      // console.log("cargando...")
    }
    // if(!argsDocum.desdeF){
    //   errors.push({path: "Desde", message: "Debe seleccionar la fecha inicial de procesos de facturación"});
    // }
    // if(!argsDocum.hastaF){
    //   errors.push({path: "Hasta", message: "Debe seleccionar la fecha final de procesos de facturación"});
    // }
    this.setState({errors})
    if(errors.length===0){
      let clientesFra = []
      // let argsBuscarCL = this.props.argsBuscar
      let argsBuscarCL = {}
      argsBuscarCL.descrDpto=null
      argsBuscarCL.nombreCiudad=null
      argsBuscarCL.nombreZona=null
      argsBuscarCL.nombreBarrio=null

      // console.log(argsBuscarCL)
      if(!argsBuscarCL.contrato){
        argsBuscarCL.contrato=null
      }

      let listFact = [], listFactTemp = []
      if(archPdf!=="nohaydatos"){
        const response = await this.props.fecha({
          variables: {}
        });
    
        var miLista = document.getElementById("miListaP");
        // let argsBuscarFact = `fechaMov: {$gte: new Date('${argsDocum.desdeF}'), $lte: new Date('${argsDocum.hastaF}')}, tipoGen: "proceso", codProcFact: {$ne: "ANULADA"},`
        let argsBuscarFact = `estadoCliente: "ACTIVO",`
        // if(miLista.options[miLista.selectedIndex].text!=="Todos..."){
        //   argsBuscarFact += `'codProcFact': '${miLista.options[miLista.selectedIndex].attributes[1].value}',`
        // }
        if(this.state.argsDocum.contrato){
          argsBuscarFact += `'contrato': '${this.state.argsDocum.contrato}',`
        }
        if(!this.state.argsSelDpto.descrDpto||this.state.argsSelDpto.descrDpto==="Todos..."){
  
        }else{
          if(!this.state.argsSelDpto.nombreCiudad||this.state.argsSelDpto.nombreCiudad==="Todas..."){
            argsBuscarFact += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}',`
          }else{
            if(!this.state.argsSelDpto.nombreZona||this.state.argsSelDpto.nombreZona==="Todas..."){
              argsBuscarFact += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}',`
              argsBuscarFact += `'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}',`
            }else{
              if(!this.state.argsSelDpto.nombreBarrio||this.state.argsSelDpto.nombreBarrio==="Todos..."){
                argsBuscarFact += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}',`
                argsBuscarFact += `'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}',`
                argsBuscarFact += `'dirmayor.ciudades.zonas.nombreZona': '${this.state.argsSelDpto.nombreZona}',`
              }else{
                argsBuscarFact += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}',`
                argsBuscarFact += `'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}',`
                argsBuscarFact += `'dirmayor.ciudades.zonas.nombreZona': '${this.state.argsSelDpto.nombreZona}',`
                argsBuscarFact += `'dirmayor.ciudades.zonas.barrios.nombreBarrio': '${this.state.argsSelDpto.nombreBarrio}',`
              }
            }
          }
        }
        // console.log(argsBuscarFact)
        argsBuscarFact = '{' + argsBuscarFact + '}'

        // console.log(argsBuscarFact)
        let tipoqry = `[{$match: ${argsBuscarFact}},`
        let argsBuscarFactSP = `{$match: {'saldoPendiente': {$gt: 0}}},`
        if(argsDocum.checkSaldoPendiente){
          argsBuscarFactSP = `{$match: {'saldoPendiente': {$gt: ${argsDocum.saldoPendiente}}}},`
        }
        argsBuscarFact = {tipoqry: `${tipoqry}
          ${argsBuscarFactSP}
          {$project: {contrato: 1, nombreCliente: 1, apellidoCliente: 1, saldoPendiente: 1,
              dirmayor: 1, eMail: 1, telefono1: 1, numeroDoc: 1, envFraCorreo: 'pantalla',
              infAdic1: '${this.props.empresa.prefijoServ}'}},
        ]`}
        // console.log(argsBuscarFact)
        if(argsBuscarFact){
          let {data} = await this.props.allClientesRtes.refetch(argsBuscarFact)
          listFactTemp = await data.allClientesRtes
        }

        for(let ii=0; ii<listFactTemp.length; ii++){
        //   // let elemento = {...listFactTemp[ii], eMail: listFactTemp[ii].cliente[0].eMail?listFactTemp[ii].cliente[0].eMail:"", telefono1: listFactTemp[ii].cliente[0].telefono1?listFactTemp[ii].cliente[0].telefono1:""}
        //   let elemento = {...listFactTemp[ii]}
        //   let indexSearchC = 0
        //   // if(argsDocum.checkSaldoPendiente||argsDocum.checkMora){
        //     if(argsDocum.checkSaldoPendiente){
        //       if(elemento.saldoPendiente<=argsDocum.saldoPendiente){
        //         indexSearchC = -1
        //       }
        //     }
        //   //   if(argsDocum.checkMora&&indexSearchC!==-1){
        //   //     if(elemento.cliente[0].diasMora>argsDocum.diasMora){
        //   //       indexSearchC = -1
        //   //     }
        //   //   }  
        //   // }
        //   if(indexSearchC!==-1){
        //     // let documFra = elemento
        //     // let modeloCodBarras = this.props.empresa.modeloCodBarras
        //     // let codBarrasRdo = elemento.codBarrasRdo?elemento.codBarrasRdo:this.props.codBarrasRdo
        //     // let imgSource = await codBarras(documFra, modeloCodBarras, codBarrasRdo)
        //     // listFact.push({...elemento, codBarras: imgSource})
            listFact.push({...listFactTemp[ii]})
        //     // clientesFra.push(elemento.cliente[0])
        //   }
        }
        this.setState({listFact, totFras: listFact.length, clientesFra})
      }
      this.setState({stImprFact: false})
    }
    document.body.style.cursor = 'default'
  }

  handleSubmitCsv = (ev) => {
    let errors = []
    if(this.state.listFact.length===0){
      errors.push({path: "Arch CSV", message: "NO hay facturas para generar archivo CSV"});
    }
    this.setState({errors})
    if(errors.length===0){
      let nombreArch = "clientesenvonepay.csv"
      let txtString = ""
      txtString += 'Contrato;Nombre(s);Apellido(s);Documento;Saldo pendiente;Email;Teléfono;Barrio;'
      txtString += "\r\n";
      let listFact = this.state.listFact
      for(let i=0; i<listFact.length; i++){
        txtString += listFact[i].contrato + ';' + listFact[i].nombreCliente + ';' + listFact[i].apellidoCliente + ';'
        txtString += listFact[i].numeroDoc + ';' + listFact[i].saldoPendiente + ';'
        txtString += listFact[i].eMail + ';' + listFact[i].telefono1 + ';'
        txtString += listFact[i].dirmayor.ciudades.zonas.barrios.nombreBarrio
        
        txtString += "\r\n";
      }

      var blob = new Blob([txtString], {type: "text/plain;charset=utf-8"});
      saveAs(blob, nombreArch);
    }
  }

  // handleImprimirTablaXls = (ev) => {
  //   var tableToExcel = (function() {
  //     var tmpElemento = document.createElement('a')
  //   //window.btoa => Encode a string in base-64
  //     var uri = 'data:application/vnd.ms-excel;base64,'
  //       , template = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
  //                           xmlns:x="urn:schemas-microsoft-com:office:excel">
  //                       <head>
  //                         <!--[if gte mso 9]>
  //                           <xml><x:ExcelWorkbook>
  //                                 <x:ExcelWorksheets>
  //                                   <x:ExcelWorksheet>
  //                                     <x:Name>{worksheet}</x:Name>
  //                                     <x:WorksheetOptions><x:DisplayGridlines/>
  //                                     </x:WorksheetOptions>
  //                                   </x:ExcelWorksheet>
  //                                 </x:ExcelWorksheets>
  //                               </x:ExcelWorkbook>
  //                           </xml>
  //                         <![endif]-->
  //                       </head>
  //                       <body><table>{table}</table></body>
  //                     </html>`
  //       , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
  //       , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
  //     return function(table, hoja) {
  //       if (!table.nodeType) table = document.getElementById(table)
  //       var ctx = {worksheet: hoja || 'Worksheet', table: table.innerHTML}
  //       tmpElemento.href = uri + base64(format(template, ctx))
  //       tmpElemento.download = 'frasenvcorreo.xls';
  //       tmpElemento.click();
  //     }
  //   })()

  //   tableToExcel('tablaFras', 'facturas')
  // }

  handleEnvCorreo = async (ev, listFact, factPdf_envCorr) => {
    if(factPdf_envCorr==="btnenvCorr"){
      let archPdf = ev.target.name

      document.body.style.cursor = 'wait'
      let errors = []

      if(!this.props.list||!this.props.list2||!this.props.allClientesRtes.allClientesRtes){
        errors.push({path: "Enviar Fact", message: "Proceso de cargue de la información, por favor espere un momento..."});
        archPdf = "nohaydatos"
        // console.log("cargando...")
      }
      this.setState({errors})
      if(errors.length===0){
        let clientesFra = []
        let argsBuscarCL = {}
        argsBuscarCL.descrDpto=null
        argsBuscarCL.nombreCiudad=null
        argsBuscarCL.nombreZona=null
        argsBuscarCL.nombreBarrio=null

        // console.log(argsBuscarCL)
        if(!argsBuscarCL.contrato){
          argsBuscarCL.contrato=null
        }

        let listFact = [], listFactTemp = []
        if(archPdf!=="nohaydatos"){
          const response = await this.props.fecha({
            variables: {}
          });
      
          var miLista = document.getElementById("miListaP");
          // let argsBuscarFact = `fechaMov: {$gte: new Date('${argsDocum.desdeF}'), $lte: new Date('${argsDocum.hastaF}')}, tipoGen: "proceso", codProcFact: {$ne: "ANULADA"},`
          let argsBuscarFact = `estadoCliente: "ACTIVO",`
          // if(miLista.options[miLista.selectedIndex].text!=="Todos..."){
          //   argsBuscarFact += `'codProcFact': '${miLista.options[miLista.selectedIndex].attributes[1].value}',`
          // }
          if(this.state.argsDocum.contrato){
            argsBuscarFact += `'contrato': '${this.state.argsDocum.contrato}',`
          }
          if(!this.state.argsSelDpto.descrDpto||this.state.argsSelDpto.descrDpto==="Todos..."){
    
          }else{
            if(!this.state.argsSelDpto.nombreCiudad||this.state.argsSelDpto.nombreCiudad==="Todas..."){
              argsBuscarFact += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}',`
            }else{
              if(!this.state.argsSelDpto.nombreZona||this.state.argsSelDpto.nombreZona==="Todas..."){
                argsBuscarFact += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}',`
                argsBuscarFact += `'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}',`
              }else{
                if(!this.state.argsSelDpto.nombreBarrio||this.state.argsSelDpto.nombreBarrio==="Todos..."){
                  argsBuscarFact += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}',`
                  argsBuscarFact += `'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}',`
                  argsBuscarFact += `'dirmayor.ciudades.zonas.nombreZona': '${this.state.argsSelDpto.nombreZona}',`
                }else{
                  argsBuscarFact += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}',`
                  argsBuscarFact += `'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}',`
                  argsBuscarFact += `'dirmayor.ciudades.zonas.nombreZona': '${this.state.argsSelDpto.nombreZona}',`
                  argsBuscarFact += `'dirmayor.ciudades.zonas.barrios.nombreBarrio': '${this.state.argsSelDpto.nombreBarrio}',`
                }
              }
            }
          }
          argsBuscarFact = '{' + argsBuscarFact + '}'

          // console.log(argsBuscarFact)
          let tipoqry = `[{$match: ${argsBuscarFact}},`
        let argsBuscarFactSP = `{$match: {'saldoPendiente': {$gt: 0}}},`
        if(this.state.argsDocum.checkSaldoPendiente){
          argsBuscarFactSP = `{$match: {'saldoPendiente': {$gt: ${this.state.argsDocum.saldoPendiente}}}},`
        }
        argsBuscarFact = {tipoqry: `${tipoqry}
          ${argsBuscarFactSP}
            {$project: {contrato: 1, nombreCliente: 1, apellidoCliente: 1, saldoPendiente: 1,
              dirmayor: 1, eMail: 1, telefono1: 1, numeroDoc: 1, envFraCorreo: 'onepay',
              infAdic1: '${this.props.empresa.prefijoServ}'}},
          ]`}
          if(argsBuscarFact){
            let {data} = await this.props.allClientesRtes.refetch(argsBuscarFact)
            listFactTemp = await data.allClientesRtes
            // console.log(listFactTemp)
          }
        }
      }
      document.body.style.cursor = 'default'
    }

    this.setState({confirmaAct: false})
    this.setState({open: false})
  }

  handleQuestionUpdDel = async (ev) => {
    if(ev.target.attributes[1].value==="btnenvCorr"||ev.target.attributes[1].value==="btnfactPdf"){
      this.setState({factPdf_envCorr: ev.target.attributes[1].value})
    }
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = document.getElementById("btnUpdDel");
        // if(myBtn){
          myBtn.click()
        // }
    }
    if(btnPress==="btnUpdDel"){
      this.setState({confirmaAct: false})
    };
  }

  async UNSAFE_componentWillMount(){
    if(this.state.argsDocum.hastaF===""){
      const argsDocum = this.state.argsDocum
      const response = await this.props.fecha({
        variables: {}
      });
      const {fechaFechaHoy} = await response.data.fecha
      argsDocum['hastaF'] = fechaFechaHoy.substr(0,10)
      this.setState(argsDocum)
    }
  }

  async componentDidUpdate(prevProps, prevState){
    if(this.props.argsSelDpto.codigoCiudad!==undefined&&this.props.argsSelDpto.codigoCiudad!==""){
      let miLista = document.getElementById("miLista1");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoCiudad){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreCiudad'] = "Todas..."
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoZona!==undefined&&this.props.argsSelDpto.codigoZona!==""){
      let miLista = document.getElementById("miLista2");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoZona){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreZona'] = "Todas..."
        argsSelDpto['codigoZona'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoBarrio!==undefined&&this.props.argsSelDpto.codigoBarrio!==""){
      let miLista = document.getElementById("miLista3");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoBarrio){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreBarrio'] = "Todos..."
        argsSelDpto['codigoBarrio'] = ""
        argsSelDpto['codigoTipoDocT'] = ""
        argsSelDpto['numeroDocumT'] = ""
        argsSelDpto['descrRecursoT'] = ""
        argsSelDpto['codigoTipoDocR'] = ""
        argsSelDpto['numeroDocumR'] = ""
        argsSelDpto['descrRecursoR'] = ""
        this.setState({argsSelDpto})
      }
    }

    if(this.state.stImprFact!==prevState.stImprFact){
      this.setState({stImprFact: false})
    }
  }

  render(){
    const {argsDocum, totFras, listFact, stImprFact, clientesFra, factPdf_envCorr, permiteUpdate, confirmaAct, open, errors} = this.state;
    const a051301 = this.props.autorizacUA.findIndex( autorizac => autorizac === "051301" );
    const a051310 = this.props.autorizacUA.findIndex( autorizac => autorizac === "051310" );

    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
  
    // const fechaHoy = new Date()
    // let agnoHoy = fechaHoy.getFullYear()
    // let mesHoy = ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1))
    // mesHoy = agnoHoy + "-" + mesHoy
    // let mesMsg = ""
    // argsDocum.mes?mesMsg=argsDocum.mes:mesMsg=mesHoy
    // // let imgIcon = "images/archivo_32.png"
    // console.log(this.props.empresa)
    if(this.props.codigoCiudadUA!=="Todas..."){
      let dpto = document.getElementById("miLista");
      if(dpto){
        // console.log(this.props.list1)
        dpto.options.selectedIndex = 0
      }
    }

    let colecc = selDirmayor(this.props.list1, this.props.argsSelDpto, this.props.codigoCiudadUA)
    let listCiu = colecc.listCiu
    let listZon = colecc.listZon
    let listBar = colecc.listBar

    
    let procMes = []
    this.props.list2.forEach((elemento, i) => {
      if(elemento.fechaCreate.substr(0, 10)>=argsDocum.desdeF&&elemento.fechaCreate.substr(0, 10)<=argsDocum.hastaF){
        procMes.push(elemento)
      }
    })
    // console.log(listFact)
    // let procMes = this.props.list2.filter(elemento => elemento.mes===mesMsg)
    // console.log(this.props.argsSelDpto, argsSelDpto)
    // console.log(stImprFact, imprFactCl)
    // let listFactCl = []
    // let imprFactCl = true
    // if(stImprFact){
    //   // console.log("11", clientesFra)
    //   // listFact.forEach((elemento, i) => {
    //   for(let i=0; i<listFact.length; i++){
    //     let elemento = listFact[i]
    //     let indexSearch = clientesFra.findIndex( cliente => cliente.contrato===elemento.contrato )
    //     if(indexSearch===-1){
    //       imprFactCl = false
    //     }
    //     listFactCl.push({listFact: listFact[i], clientesFra: clientesFra[indexSearch]})
    //   }
    //   // })
    //   // console.log("22")
    // }
    //     console.log(stImprFact, imprFactCl)
    // console.log(listFact)
    // console.log(this.props.argsBuscar)
    // console.log(this.props.empresa)
    // console.log(argsDocum)
    let mensaje = "ENVIAR A ONEPAY (" + totFras + ")"
    let imgIcon = "images/envcorreo_32.png"
    let userLogin = sessionStorage.getItem('userLogin')
    // console.log(userLogin)
    // console.log(errors.length)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
            <i className="large plus yellow icon"></i>
            Enviar fact a ONEPAY
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1">
              <div>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '80%'}}>
                      <h1 style={{color: '#2C7744'}}>Enviar facturación a ONEPAY (Activos con saldo mayor a cero)</h1>
                    </div>
                  </div>
                </div>
                

                <hr></hr>
                {/* <br/>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Seleccionar archivo CSV...&nbsp;&nbsp;
                      </label>
                      <input id="archcsv" name="archcsv" type="file" accept=".csv" style={estilos} onChange={this.handleChangeCSV}></input>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                          <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkTieneEncab"
                                  name="checkTieneEncab" onChange={this.handleChangeCSV}/>
                          &nbsp;&nbsp;Tiene encabezados en la primera fila
                        </p>
                      </Form.Field>
                    </div>

                  </div>
                </div>
                <br/>
                <hr></hr>

                <hr></hr> */}
                {/* <div className="ui four column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '25%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Procesos fact desde
                      </p>
                      <Form.Field>
                        <input style={this.props.styles.input} type='date' name="desdeF" id="desdeF" value={argsDocum.desdeF} onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '25%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Hasta
                      </p>
                      <Form.Field>
                        <input style={this.props.styles.input} type='date' name="hastaF" id="hastaF" value={argsDocum.hastaF} onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <hr></hr> */}
                <div className="ui two column stackable grid">
                  <div className="row container">
                    {/* <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Procesos de facturación
                        </label>
                        <Lista styles={this.props.styles} list={procMes} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div> */}
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Contrato
                        </label>
                        <input style={this.props.styles.input} autoComplete="off" name="contrato" id="contrato" onChange={this.handleChange} placeholder='Contrato'/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '25%'}}>
                      <Form.Field>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkSaldoPendiente" checked={argsDocum.checkSaldoPendiente} onChange={this.handleChange}/>
                          &nbsp;&nbsp;Clientes con Saldo mayor a
                        </p>
                        <input value={argsDocum.saldoPendiente} type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="saldoPendiente" id="saldoPendiente" placeholder='Saldo pendiente' onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>

                <hr></hr>

                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Departamento
                        </label>
                        <ListaDe list={this.props.list1} styles={this.props.styles}
                          handleLista={this.props.handleLista} codigoCiudadUA={this.props.codigoCiudadUA}
                          codigoDptoUA={this.props.codigoDptoUA}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Ciudad
                        </label>
                        <ListaCi list={listCiu} styles={this.props.styles}
                          handleLista1={this.props.handleLista1} argsSelDpto={this.props.argsSelDpto}
                          codigoCiudadUA={this.props.codigoCiudadUA}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Zona
                        </label>
                        <ListaZo list={listZon} styles={this.props.styles} handleLista2={this.props.handleLista2} argsSelDpto={this.props.argsSelDpto}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Barrio
                        </label>
                        <ListaBa list={listBar} styles={this.props.styles} handleLista3={this.props.handleLista3} argsSelDpto={this.props.argsSelDpto}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Total facturas:&nbsp;{totFras}&nbsp;&nbsp;&nbsp;&nbsp;
                  {/* {a051301!==-1 &&
                    <a className='ui large label' style={this.props.styles.styTableInf} onClick={(ev)=>this.handleImprimirTablaXls(ev)}><i className='file excel outline icon'></i>Excel</a>
                  } */}
                </p>
                <Modal open={open} size="tiny" style={this.props.styles.modal} trigger={

                <div className="ui four column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '33%'}}>
                      <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum)} fluid>
                          VER RESUMEN EN PANTALLA
                      </Button>
                    </div>
                    {/* <div className="column" style={{width: '25%'}}>
                      {a051301!==-1 &&
                        <Button name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleImprimirTablaXls(ev)} fluid>
                          ARCHIVO EXCEL
                        </Button>
                      }
                    </div> */}
                    <div className="column" style={{width: '33%'}}>
                      {a051301!==-1 &&
                        <Button name="csv" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmitCsv(ev)} fluid>
                          ARCHIVO CSV
                        </Button>
                      }
                    </div>
                    {/* <div className="column" style={{width: '25%'}}>
                      {(a051305!==-1) &&
                        <Button name="btnUpdDel" id="btnfactPdf" style={this.props.styles.confirmar} onClick={(ev)=>this.handleQuestionUpdDel(ev)} fluid>
                          GENERAR FACTURAS EN PDF
                        </Button>
                      }
                    </div> */}
                    <div className="column" style={{width: '33%'}}>
                      {(a051310!==-1) &&
                        // <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>

                        <Button name="btnUpdDel" id="btnenvCorr" style={this.props.styles.confirmar} onClick={(ev)=>this.handleQuestionUpdDel(ev)} fluid>
                        {/* <Button name="correo" style={this.props.styles.confirmar} fluid> */}
                          ENVIAR A ONEPAY
                        </Button>
                      }
                    </div>
                  </div>
                </div>
                }>
                <Header icon='edit' color='red' content={factPdf_envCorr==="btnenvCorr"?`${mensaje})`:`GENERAR FACTURAS EN PDF`} />      
                <Modal.Content>
                  <p>Esta usted seguro ?</p>
                </Modal.Content>
                <Modal.Actions>
                  <Button dato1="No" name='btnNoUpd' color='red' onClick={(ev)=>this.handleQuestionUpdDel(ev)}>
                    <Icon dato1="No" name='remove' /> No
                  </Button>
                  <Button dato1="Si" name='btnSiUpd' color='green' onClick={(ev)=>this.handleEnvCorreo(ev, listFact, factPdf_envCorr)}>
                    <Icon dato1="Si" name='checkmark' /> Si
                  </Button>
                </Modal.Actions>
              </Modal>

                <hr></hr>
                        
                {
                    errors.length?<Message negative header="Los siguientes errores:"
                    list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
                <table id="tablaFras" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{width: '10%'}}>Contrato</th>
                      <th className='' style={{width: '15%'}}>Nombre(s)</th>
                      <th className='' style={{width: '15%'}}>Apellido(s)</th>
                      <th className='' style={{width: '12%'}}>Documento</th>
                      <th className='right aligned' style={{width: '10%'}}>$ Saldo pendiente</th>
                      <th className='' style={{width: '15%'}}>Email</th>
                      <th className='' style={{width: '12%'}}>Teléfono</th>
                      <th className='' style={{width: '18%'}}>Barrio</th>
                    </tr>
                  </thead>
                  <ListaFact list={listFact}/>
                </table>
              </div>
            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  // graphql(queries.query.allFacturacion, {name:'allFacturacion', options: (props) => {return {variables: {fechaMov: { $gte: "2019-04-08", $lte: "2019-04-08" }}}}}),
  // graphql(queries.query.allFactRtes, {name:'allFactRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {fechaFact: new Date("2018-04-07")}}]`}}}}),

  graphql(queries.query.allClientesRtes, {name:'allClientesRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {contrato: "XXXYYYZZZ"}}]`}}}}),
  
  graphql(queries.mutation.enviarCorreoFact, {name:'enviarCorreoFact'}),

  // graphql(queries.query.allCliBasico, {name:'allCliBasico', options: (props) => {return {variables: {contrato: "XYZ321"}}}}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(FactONE2)
